import { ButtonPropsType } from "../components/content/Alert/types";
import { Props as ButtonProps } from "../components/controls/Button/Button";
import { Props as ButtonLinkProps } from "../components/controls/ButtonLink/ButtonLink";

function isButtonType(buttonProps?: ButtonPropsType) {
  return !!(buttonProps && !("to" in buttonProps));
}

export function isButtonLink(buttonProps: any): buttonProps is ButtonLinkProps {
  const isButton = isButtonType(buttonProps);
  return !isButton;
}

export function isButton(buttonProps: any): buttonProps is ButtonProps {
  const isButton = isButtonType(buttonProps);
  return isButton;
}
